import React, {useMemo,useRef,useEffect,useState,forwardRef,useImperativeHandle} from "react";
import {useStripe, useElements, CardElement} from "@stripe/react-stripe-js";
import { useHistory } from 'react-router-dom';
import CountryService from '../../../../../utils/country';
import StatesService from '../../../../../utils/states';
import DataSource from 'devextreme/data/data_source';
import Form, {Label, SimpleItem, GroupItem, ButtonItem, RequiredRule, EmailRule} from 'devextreme-react/form';
import paymentApi from '../../../../../api/payment';
import { LoadPanel } from 'devextreme-react/load-panel';
import sessions from '../../../../../sessions';
import notify from 'devextreme/ui/notify';

const useOptions = () => {
    const options = useMemo(() => ({
        style: {
            base: {
                fontSize:'16px',
                color: "rgba(117,117,117,.67)",
                letterSpacing: "0.025em",
                fontFamily: "Roboto,RobotoFallback,Helvetica,Arial,sans-serif",
                "::placeholder": {
                    color: "rgba(117,117,117,.67)"
                }
            },
            invalid: {
                color: "#9e2146"
            }
        }
    }), []);

    return options;
};

const CardForm = forwardRef((props,ref) => {
    const userId = sessions.getSession("user")?.id;
    const userEmail = sessions.getSession("user")?.email;
    const stripe = useStripe();
    const elements = useElements();
    const options = useOptions();
    const informationForm = useRef({});
    const checkoutForm = useRef({});
    const [isOptionA, setIsOptionA] = useState(false);
    const [isOptionB, setIsOptionB] = useState(false);
    const [isOptionC, setIsOptionC] = useState(false);
    const [isloadPanelVisible, setIsloadPanelVisible] = useState(false);
    const [countryValue, setCountryValue] = useState('');
    const auth = sessions.getSession("user")?.accessToken;
    const history = useHistory();
    const CountryOnChange = ({value}) => {setCountryValue(value)};

    const country = new DataSource({
        store: {
            type: 'array',
            data: CountryService,
            key: 'iso2'
        },
        pageSize: 10,
        paginate: true
    });

    const state = new DataSource({
        store: {
            data: StatesService,
            type: 'array',
            key: 'name'
        },
        filter: [
            "country_code", "=", countryValue
        ],
        pageSize: 10,
        paginate: true
    });

    const optionButtonOnClick = (value) => {
        if(value === 'A'){
            setIsOptionA(true);
            setIsOptionB(false);
            setIsOptionC(false);
        }else if(value === 'B'){
            setIsOptionA(false);
            setIsOptionB(true);
            setIsOptionC(false);
        }else if(value === 'C'){
            setIsOptionA(false);
            setIsOptionB(false);
            setIsOptionC(true);
        }
    };

    const onSubmit = (async(e) => {
        if(e)e.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable form submission until
            // Stripe.js has loaded.
            return;
        };

        const cardElement = elements.getElement(CardElement);
        const {name, email,phone,country,city,address} =  informationForm.current;

        var payload = {};
        var amount = 0;
        if(isOptionA)
            amount = 150;
        else if(isOptionB)
            amount = 300;
        else if(isOptionC)
            amount = 500;
        else{
            const {funds} = checkoutForm.current;
            amount = funds;
        } 
        if(!amount)
            notify(`Please filled the amount of money.`,"error",500);
        else{
            const {error, paymentMethod} =  await stripe.createPaymentMethod({
                type: 'card',
                card: cardElement
            });
            if (error) {
                console.log('[error]', error);
            } else {
                setIsloadPanelVisible(true);
                payload = {
                    paymentMethod:paymentMethod,
                    address:informationForm.current,
                    amount:amount
                };
                await paymentApi.createPaymentIntent(userId,payload,auth).then(async(result)=>{
                    var clientSecret  = result.data;
                    console.log("email result",email+result);
                    await stripe.confirmCardPayment(clientSecret, {
                        receipt_email: email,
                        payment_method: {
                          card: elements.getElement(CardElement)
                        }
                    });
                    setIsloadPanelVisible(false);
                    notify(`✔️ succesfully add ${amount} USD to your account`,"success",500);
                    history.replace(`/settings/subscription-plans`);
                }).catch(err=>{
                    console.log(err);
                    setIsloadPanelVisible(false);
                    notify(`❌ Please try again later`,"error",500);
                });
            }
        }
    });

    const fundButtonOnFocus = () => {
        setIsOptionA(false);
        setIsOptionB(false);
        setIsOptionC(false);
    }

    useImperativeHandle(ref, (e) => ({onSubmit}));

    return (
        <form id={'stripes-form'} onSubmit={onSubmit}>
            <Form formData={checkoutForm.current} colCount={5} labelLocation={'left'}>
                <ButtonItem 
                    id={'optionA'}
                    dataField={'150'}
                    editorOptions={{
                        stylingMode:'outlined',
                        type:isOptionA?'default':'normal',
                        text:'150 USD',
                        onClick:(e)=>{optionButtonOnClick('A')}
                    }}
                >
                </ButtonItem>
                <ButtonItem 
                    id={'optionB'}
                    dataField={'300'}
                    editorOptions={{
                        stylingMode:'outlined',
                        type:isOptionB?'default':'normal',
                        text:'300 USD',
                        onClick:(e)=>{optionButtonOnClick('B')}
                    }}
                >
                </ButtonItem>
                <ButtonItem
                    id={'optionC'} 
                    dataField={'500'}
                    editorOptions={{
                        stylingMode:'outlined',
                        type:isOptionC?'default':'normal',
                        text:'500 USD',
                        onClick:(e)=>{optionButtonOnClick('C')}
                    }}
                >
                </ButtonItem>
                <SimpleItem 
                editorType="dxNumberBox" 
                dataField={'funds'} 
                editorOptions={{
                    stylingMode:'outlined',
                    height:'35px',
                    width:'13vw',
                    format:'$ #.##',
                    onFocusIn:fundButtonOnFocus}}>
                    <Label text={'or'}/>
                </SimpleItem>
            </Form>
            <Form formData={informationForm.current}>
                <GroupItem dataField={'BILLING INFORMATION'} colCount={2}>
                    <SimpleItem dataField={'name'} editorOptions={{placeholder: 'John Doe'}} colSpan={2}>
                        <Label text={'Card Holder Name'}/>
                        <RequiredRule message="name is required"/>
                    </SimpleItem>
                    <SimpleItem 
                        dataField={'email'}
                        editorOptions={{
                            placeholder: 'johndoe@gmail.com',
                            mode: 'email',
                        }}>
                        <RequiredRule message="Email is required" />
                        <EmailRule message="Email is invalid"/>
                    </SimpleItem>
                    <SimpleItem dataField={'phone'} editorOptions={{placeholder: '+00 111000111'}}>
                        <RequiredRule message="phone is required"/>
                    </SimpleItem>
                    <SimpleItem
                        editorType={'dxSelectBox'}
                        dataField="country"
                        editorOptions={{
                        dataSource: country,
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr: 'iso2',
                        onValueChanged: CountryOnChange
                    }}>
                        <RequiredRule message="country is required"/>
                    </SimpleItem>
                    <SimpleItem
                        dataField="state"
                        editorType="dxSelectBox"
                        editorOptions={{
                        dataSource: state,
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr: 'name'
                    }}>
                        <RequiredRule message="state is required"/>
                    </SimpleItem>
                    <SimpleItem dataField={'city'} editorOptions={{placeholder: 'San Francisco'}}>
                        <RequiredRule message="city is required"/>
                    </SimpleItem>
                    <SimpleItem dataField={'address'} editorOptions={{placeholder: '185 Berry Street Suite 550'}}>
                        <RequiredRule message="address is required"/>
                    </SimpleItem>
                </GroupItem>
                <GroupItem dataField={'PAYMENT INFORMATION'} colCount={2}>
                    <SimpleItem colSpan={2}>
                        <CardElement options={options}/>
                    </SimpleItem>
                </GroupItem>
            </Form>
            <LoadPanel
                position={'#stripes-form'}
                shadingColor="rgba(0, 0, 0, 0.2)"
                onHiding={!isloadPanelVisible}
                visible={isloadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                message={'loading..'}
                closeOnOutsideClick={false}/>
        </form>
    );
});

export default CardForm;
